import React, { useState } from 'react';
import { Calendar, MapPin, Users, Clock, Plus, Heart, Sparkles, Filter, Search } from 'lucide-react';

const MOCK_EVENTS = [
  { id: '1', title: 'Speed Dating Paris', desc: 'Rencontrez 10 personnes en une soiree dans un cadre intimiste.', location: 'Paris, Le Marais', date: '2026-04-20', time: '20:00', attendees: 24, max: 30, category: 'speed-dating', image: null, premium: false },
  { id: '2', title: 'Soiree Afterwork Celibataires', desc: 'Un verre entre celibataires dans une ambiance decontractee.', location: 'Lyon, Presqu\'ile', date: '2026-04-22', time: '19:00', attendees: 45, max: 60, category: 'afterwork', image: null, premium: false },
  { id: '3', title: 'Brunch & Dating', desc: 'Un brunch gourmand pour faire des rencontres autour d\'un repas.', location: 'Bordeaux, Centre', date: '2026-04-25', time: '11:00', attendees: 18, max: 20, category: 'brunch', image: null, premium: true },
  { id: '4', title: 'Randonnee Celibataires', desc: 'Decouvrez la nature et rencontrez des personnes qui partagent votre passion.', location: 'Nice, Collines', date: '2026-04-27', time: '09:00', attendees: 30, max: 40, category: 'outdoor', image: null, premium: false },
  { id: '5', title: 'Atelier Cuisine & Flirt', desc: 'Apprenez a cuisiner ensemble et laissez la magie operer.', location: 'Paris, Bastille', date: '2026-05-02', time: '18:30', attendees: 12, max: 16, category: 'atelier', image: null, premium: true },
  { id: '6', title: 'Soiree Jeux de Societe', desc: 'Des jeux, du rire et des rencontres dans une ambiance ludique.', location: 'Marseille, Vieux Port', date: '2026-05-05', time: '20:00', attendees: 28, max: 35, category: 'games', image: null, premium: false },
];

const CATEGORIES = [
  { key: 'all', label: 'Tous' },
  { key: 'speed-dating', label: 'Speed Dating' },
  { key: 'afterwork', label: 'Afterwork' },
  { key: 'outdoor', label: 'Plein air' },
  { key: 'atelier', label: 'Ateliers' },
  { key: 'brunch', label: 'Brunch' },
  { key: 'games', label: 'Jeux' },
];

const CAT_COLORS = {
  'speed-dating': 'from-brand-pink to-rose-500',
  'afterwork': 'from-brand-violet to-purple-500',
  'brunch': 'from-amber-400 to-orange-500',
  'outdoor': 'from-emerald-500 to-green-500',
  'atelier': 'from-brand-blue to-cyan-500',
  'games': 'from-indigo-500 to-violet-500',
};

export default function Events() {
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');
  const [joined, setJoined] = useState({});

  const filtered = MOCK_EVENTS.filter(e =>
    (filter === 'all' || e.category === filter) &&
    (search === '' || e.title.toLowerCase().includes(search.toLowerCase()) || e.location.toLowerCase().includes(search.toLowerCase()))
  );

  const handleJoin = (id) => {
    setJoined(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
  };

  return (
    <div className="h-full overflow-y-auto" data-testid="events-page">
      <header className="px-8 py-6" style={{borderBottom:'1px solid var(--border-color)'}}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Calendar size={24} className="text-brand-pink" />
            <div>
              <h1 className="text-2xl font-black" style={{color:'var(--text-primary)'}}>Evenements</h1>
              <p className="text-sm mt-0.5" style={{color:'var(--text-muted)'}}>Rencontres en vrai — Exclusif Web</p>
            </div>
          </div>
          <button className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-brand-pink to-brand-violet text-white font-semibold text-sm hover:shadow-lg hover:shadow-brand-pink/20 transition-all" data-testid="create-event-btn">
            <Plus size={16} /> Creer un event
          </button>
        </div>
      </header>

      <div className="max-w-6xl mx-auto p-6 space-y-6">
        {/* Search + Filters */}
        <div className="flex flex-col lg:flex-row gap-4">
          <div className="relative flex-1">
            <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2" style={{color:'var(--text-faint)'}} />
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Rechercher un evenement..." className="input-field !pl-12 !rounded-full" data-testid="events-search" />
          </div>
          <div className="flex gap-2 overflow-x-auto pb-1">
            {CATEGORIES.map(cat => (
              <button key={cat.key} onClick={() => setFilter(cat.key)}
                className={`px-4 py-2 rounded-full text-xs font-semibold whitespace-nowrap transition-all ${filter === cat.key ? 'bg-gradient-to-r from-brand-purple to-brand-violet text-white' : ''}`}
                style={filter !== cat.key ? {background:'var(--bg-card)', color:'var(--text-muted)', border:'1px solid var(--border-color)'} : undefined}
                data-testid={`filter-${cat.key}`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        {/* Events Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.map(event => {
            const gradient = CAT_COLORS[event.category] || 'from-gray-500 to-gray-600';
            const isFull = event.attendees >= event.max;
            const isJoined = joined[event.id];
            const fillPct = (event.attendees / event.max) * 100;

            return (
              <div key={event.id} className="glass-card overflow-hidden group hover:scale-[1.01] transition-transform" data-testid={`event-${event.id}`}>
                {/* Header gradient */}
                <div className={`h-28 bg-gradient-to-br ${gradient} relative flex items-end p-5`}>
                  {event.premium && (
                    <div className="absolute top-3 right-3 flex items-center gap-1 px-2.5 py-1 rounded-full bg-black/40 backdrop-blur-sm">
                      <Sparkles size={12} className="text-amber-400" />
                      <span className="text-[10px] font-bold text-amber-400">PREMIUM</span>
                    </div>
                  )}
                  <div className="absolute top-3 left-3 px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-semibold">
                    {CATEGORIES.find(c => c.key === event.category)?.label}
                  </div>
                </div>

                <div className="p-5">
                  <h3 className="text-base font-bold mb-2" style={{color:'var(--text-primary)'}}>{event.title}</h3>
                  <p className="text-xs mb-4 leading-relaxed" style={{color:'var(--text-muted)'}}>{event.desc}</p>

                  <div className="space-y-2 text-xs mb-4">
                    <div className="flex items-center gap-2" style={{color:'var(--text-secondary)'}}>
                      <Calendar size={14} className="text-brand-violet shrink-0" />
                      <span>{formatDate(event.date)} a {event.time}</span>
                    </div>
                    <div className="flex items-center gap-2" style={{color:'var(--text-secondary)'}}>
                      <MapPin size={14} className="text-brand-pink shrink-0" />
                      <span>{event.location}</span>
                    </div>
                    <div className="flex items-center gap-2" style={{color:'var(--text-secondary)'}}>
                      <Users size={14} className="text-brand-blue shrink-0" />
                      <span>{event.attendees}/{event.max} participants</span>
                    </div>
                  </div>

                  {/* Fill bar */}
                  <div className="w-full h-1.5 rounded-full mb-4" style={{background:'var(--bg-input)'}}>
                    <div className={`h-full rounded-full bg-gradient-to-r ${gradient} transition-all`} style={{width:`${fillPct}%`}} />
                  </div>

                  <button onClick={() => handleJoin(event.id)} disabled={isFull && !isJoined}
                    className={`w-full py-2.5 rounded-xl font-bold text-sm transition-all ${
                      isJoined ? 'bg-green-500/15 text-green-400 border border-green-500/30' :
                      isFull ? 'opacity-50 cursor-not-allowed' :
                      'bg-gradient-to-r from-brand-pink to-brand-violet text-white hover:shadow-lg hover:shadow-brand-pink/20'
                    }`}
                    style={(!isJoined && !isFull) ? undefined : (isFull && !isJoined) ? {background:'var(--bg-input)', color:'var(--text-muted)'} : undefined}
                    data-testid={`join-${event.id}`}
                  >
                    {isJoined ? 'Inscrit !' : isFull ? 'Complet' : 'Participer'}
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {filtered.length === 0 && (
          <div className="text-center py-16">
            <Calendar size={40} className="mx-auto mb-3" style={{color:'var(--text-faint)'}} />
            <p className="text-lg font-semibold mb-1" style={{color:'var(--text-secondary)'}}>Aucun evenement trouve</p>
            <p className="text-sm" style={{color:'var(--text-muted)'}}>Essayez de modifier vos filtres</p>
          </div>
        )}
      </div>
    </div>
  );
}
